var map = {
	"./H1.svg": 56810,
	"./H2.svg": 48185,
	"./H3.svg": 82792,
	"./Vector.svg": 5274,
	"./activity.svg": 2432,
	"./add-column-after.svg": 36934,
	"./add-column-before.svg": 14409,
	"./add-comment.svg": 90616,
	"./add-row-after.svg": 95718,
	"./add-row-before.svg": 64937,
	"./alert-circle-16x16.svg": 93925,
	"./alert-circle.svg": 59804,
	"./alert-triangle.svg": 52348,
	"./align-center.svg": 93076,
	"./align-justify-st.svg": 59979,
	"./align-left.svg": 50752,
	"./align-right.svg": 69231,
	"./anchor.svg": 70256,
	"./apple-logo-dark.svg": 43900,
	"./apple-logo.svg": 38503,
	"./archive.svg": 39363,
	"./archived.svg": 16421,
	"./arrow-down-small.svg": 72749,
	"./arrow-down.svg": 31759,
	"./arrow-left.svg": 65648,
	"./arrow-right-circle.svg": 82492,
	"./arrow-right-small.svg": 42237,
	"./arrow-right.svg": 76415,
	"./arrow-up-right.svg": 35153,
	"./arrow-up.svg": 46688,
	"./arrows-horizontal.svg": 24010,
	"./at-sign.svg": 80170,
	"./avatar.svg": 10256,
	"./award.svg": 72774,
	"./ball.svg": 40096,
	"./bell-filled.svg": 47953,
	"./bell-off.svg": 13616,
	"./bell.svg": 73516,
	"./bellv1.svg": 66535,
	"./black-flag.svg": 27075,
	"./blocquote.svg": 84225,
	"./board.svg": 10525,
	"./bold-st.svg": 9726,
	"./box.svg": 2474,
	"./briefcase.svg": 81005,
	"./calendar-created.svg": 85730,
	"./calendar.svg": 85033,
	"./camera.svg": 58854,
	"./card-child.svg": 75856,
	"./card-epic.svg": 95705,
	"./card-icon.svg": 90165,
	"./check-2.svg": 89064,
	"./check-circle.svg": 92670,
	"./check-hex-16.svg": 3807,
	"./check-hex.svg": 69265,
	"./check-square.svg": 4723,
	"./check.svg": 82497,
	"./checkbox.svg": 40548,
	"./chevron-down.svg": 79573,
	"./chevron-left.svg": 12526,
	"./chevron-right.svg": 19501,
	"./chevron-up.svg": 15738,
	"./chevrons-down.svg": 85172,
	"./chevrons-left.svg": 38195,
	"./chevrons-right.svg": 29654,
	"./chevrons-up.svg": 88975,
	"./child-branch-end-thin.svg": 56544,
	"./child-branch-end.svg": 92336,
	"./child-branch-line-thin.svg": 51853,
	"./child-branch-line.svg": 88835,
	"./child-branch-middle-thin.svg": 14898,
	"./child-branch-middle.svg": 37306,
	"./child-card.svg": 5958,
	"./chrome.svg": 6037,
	"./circle-dotted.svg": 33144,
	"./circle-full.svg": 51767,
	"./circle.svg": 77183,
	"./clipboard.svg": 75543,
	"./clock.svg": 92075,
	"./code-block.svg": 61200,
	"./code-st.svg": 87984,
	"./coffee.svg": 41391,
	"./collapse.svg": 40726,
	"./color.svg": 2788,
	"./compass.svg": 54337,
	"./component3.svg": 3671,
	"./copy.svg": 28552,
	"./corner-down-left.svg": 13705,
	"./corner-down-right.svg": 44692,
	"./cpu.svg": 5711,
	"./credit-card.svg": 48531,
	"./crosshair.svg": 96445,
	"./cursor.svg": 51849,
	"./dashed-border.svg": 44619,
	"./delete-column.svg": 9321,
	"./delete-row.svg": 15341,
	"./disc.svg": 66560,
	"./download-cloud.svg": 79275,
	"./download.svg": 91303,
	"./drag.svg": 37229,
	"./edge.svg": 36728,
	"./edit-outline.svg": 72330,
	"./edit.svg": 975,
	"./ellipse.svg": 88255,
	"./expand-horizontal.svg": 90568,
	"./expand.svg": 80863,
	"./external-link.svg": 839,
	"./eye-off.svg": 59210,
	"./eye.svg": 34426,
	"./facetime.svg": 63867,
	"./feather.svg": 8556,
	"./file.svg": 34709,
	"./firefox.svg": 82090,
	"./flag.svg": 41113,
	"./folder-open.svg": 86692,
	"./folder-plus.svg": 85924,
	"./folder.svg": 30811,
	"./front-end.svg": 67920,
	"./g-calendar.svg": 75445,
	"./gift.svg": 66081,
	"./git-pull-request.svg": 85971,
	"./github-icon.svg": 30988,
	"./github_light_icon.svg": 53657,
	"./gitlab_icon.svg": 12430,
	"./globe.svg": 5938,
	"./google-logo.svg": 82334,
	"./grid.svg": 33591,
	"./hash.svg": 29607,
	"./header-row-1.svg": 1133,
	"./header-row-2.svg": 1806,
	"./headphones.svg": 2582,
	"./heart.svg": 49733,
	"./help-circle-16x16.svg": 59698,
	"./help-circle.svg": 88303,
	"./hex-16.svg": 99278,
	"./hex-dotted.svg": 46755,
	"./hex.svg": 48690,
	"./hexagon-16.svg": 86195,
	"./hexagon-v2.svg": 31170,
	"./hexagon.svg": 57437,
	"./home.svg": 74174,
	"./image-st.svg": 45538,
	"./image.svg": 83922,
	"./inbox-unread.svg": 29839,
	"./inbox.svg": 8973,
	"./info.svg": 36947,
	"./italic-st.svg": 55881,
	"./jira.svg": 61495,
	"./jirasoftware_icon.svg": 63568,
	"./key.svg": 97000,
	"./layout.svg": 87097,
	"./life-buoy.svg": 19713,
	"./link-2.svg": 34090,
	"./link-st.svg": 97117,
	"./list.svg": 60071,
	"./loader.svg": 28138,
	"./lock.svg": 45482,
	"./log-out.svg": 40852,
	"./mac-command.svg": 85688,
	"./magnifying-glass.svg": 1291,
	"./mail.svg": 59814,
	"./map-pin.svg": 35789,
	"./map.svg": 59543,
	"./maximize-2.svg": 21864,
	"./maximize.svg": 10977,
	"./meh.svg": 24987,
	"./menu.svg": 72434,
	"./merge-cells.svg": 1393,
	"./message-circle.svg": 63493,
	"./message-square.svg": 99256,
	"./mic.svg": 35132,
	"./minimize-fullscreen.svg": 45103,
	"./minimize.svg": 9427,
	"./minus.svg": 48441,
	"./monitor.svg": 17871,
	"./moon.svg": 77628,
	"./more-horizontal.svg": 70801,
	"./more-vertical.svg": 71095,
	"./music.svg": 50504,
	"./my-work.svg": 46273,
	"./new-card-icon.svg": 30052,
	"./no-transcript.svg": 63613,
	"./note.svg": 59667,
	"./notes-logo-dark.svg": 28331,
	"./notes-logo.svg": 60010,
	"./numbered-list.svg": 65752,
	"./offline.svg": 43820,
	"./online.svg": 49674,
	"./page-icon.svg": 86488,
	"./page.svg": 18174,
	"./paint.svg": 87445,
	"./paper-box.svg": 50235,
	"./paperclip.svg": 19081,
	"./parent-card.svg": 63286,
	"./pause-circle.svg": 25032,
	"./pause.svg": 51947,
	"./play-circle.svg": 77618,
	"./play-hex-16.svg": 28443,
	"./play-hex.svg": 77253,
	"./play.svg": 10757,
	"./plus-circle.svg": 68648,
	"./plus-square.svg": 5777,
	"./plus.svg": 24491,
	"./plus2.svg": 52083,
	"./printer.svg": 89049,
	"./private-project.svg": 40572,
	"./pull_request_state.svg": 5922,
	"./reaction.svg": 50786,
	"./redo.svg": 52727,
	"./refresh-ccw.svg": 95354,
	"./refresh-cw.svg": 10427,
	"./repeat.svg": 71466,
	"./right-sidebar.svg": 22280,
	"./rocket.svg": 94563,
	"./rotate-cw.svg": 18897,
	"./safari.svg": 50223,
	"./save.svg": 44660,
	"./search-alternative.svg": 66273,
	"./send.svg": 46385,
	"./settings.svg": 20716,
	"./shield.svg": 66164,
	"./shopping-bag.svg": 73078,
	"./shortcut.svg": 75821,
	"./sidebar.svg": 31465,
	"./sidedock.svg": 85575,
	"./skip-forward.svg": 86402,
	"./slack.svg": 31745,
	"./sliders.svg": 59411,
	"./smile.svg": 21273,
	"./space.svg": 86779,
	"./sprint-cancelled.svg": 22013,
	"./sprint-completed.svg": 27367,
	"./sprint-current.svg": 55723,
	"./sprint-future.svg": 8217,
	"./square.svg": 77102,
	"./star-active.svg": 28862,
	"./star.svg": 40815,
	"./status.svg": 44417,
	"./stlogo.svg": 43731,
	"./strikethrough.svg": 37464,
	"./table.svg": 1145,
	"./table2.svg": 233,
	"./tag.svg": 48197,
	"./target.svg": 91220,
	"./teams.svg": 48963,
	"./template.svg": 79477,
	"./thumbs-down.svg": 76469,
	"./thumbs-up.svg": 31066,
	"./timeline.svg": 74590,
	"./tool.svg": 71777,
	"./transcript.svg": 43837,
	"./trash-empty.svg": 39519,
	"./trash.svg": 36891,
	"./trello.svg": 28505,
	"./trello_icon.svg": 85495,
	"./trending-up.svg": 47994,
	"./truck.svg": 1964,
	"./tv.svg": 85369,
	"./type.svg": 47203,
	"./umbrella.svg": 68035,
	"./underline-st.svg": 59375,
	"./undo.svg": 57305,
	"./unfavourite.svg": 22311,
	"./upload-cloud.svg": 23708,
	"./upload.svg": 50600,
	"./user-check.svg": 11273,
	"./user-minus.svg": 20369,
	"./user-plus.svg": 9171,
	"./user-x.svg": 62065,
	"./user.svg": 10698,
	"./video-st.svg": 41224,
	"./view.svg": 93436,
	"./volume-1.svg": 48435,
	"./volume-2.svg": 27680,
	"./volume-x.svg": 23034,
	"./watch.svg": 63708,
	"./waveform.svg": 55946,
	"./webex.svg": 67432,
	"./whatsapp.svg": 34609,
	"./workspace.svg": 92478,
	"./wrench.svg": 60552,
	"./x-circle.svg": 5046,
	"./x-hex-16.svg": 69319,
	"./x-hex.svg": 12249,
	"./x-octagon.svg": 44343,
	"./x.svg": 99897,
	"./youtube.svg": 72054,
	"./zap.svg": 80656,
	"./zapier-icon.svg": 20698,
	"./zapier-logo.svg": 69968,
	"./zoom-in.svg": 6270,
	"./zoom-out.svg": 98073,
	"./zoom.svg": 42226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87328;